import { useEffect } from 'react';
import PropTypes from 'prop-types';

const useTabsLayout = (groupRef) => {
  useEffect(() => {
    const group = groupRef.current;
    if (!group || typeof window === 'undefined') {
      return undefined;
    }

    const selectTabMobile = (el) => {
      let tabDiv = el;
      while (tabDiv && !tabDiv.classList.contains('tab')) {
        tabDiv = tabDiv.parentElement;
      }
      if (!tabDiv?.parentElement) {
        return;
      }

      tabDiv.parentElement
        .querySelectorAll('.tab-content')
        .forEach((content) => {
          content.style.maxHeight = '';
        });

      const content = tabDiv.querySelector('.tab-content');
      if (!content) {
        return;
      }

      content.style.maxHeight =
        content.scrollHeight > 0 ? `${content.scrollHeight}px` : '20000px';
    };

    const resizeTabs = (el) => {
      let tabDiv = el;
      while (tabDiv && !tabDiv.classList.contains('tab')) {
        tabDiv = tabDiv.parentElement;
      }
      if (!tabDiv?.parentElement) {
        return;
      }

      let height = 0;
      for (let i = 0; i < tabDiv.children.length; i += 1) {
        height += tabDiv.children.item(i).offsetHeight;
      }
      tabDiv.parentElement.style.minHeight = `${height}px`;
    };

    const onChange = (event) => {
      if (event.target.matches('input[type="radio"]')) {
        selectTabMobile(event.target);
        resizeTabs(event.target);
      }
    };

    const onClick = (event) => {
      if (event.target.closest('.tab-heading')) {
        selectTabMobile(event.target);
        resizeTabs(event.target);
      }
    };

    group.addEventListener('change', onChange);
    group.addEventListener('click', onClick);

    const checked = group.querySelector('input[type="radio"]:checked');
    if (checked) {
      selectTabMobile(checked);
      resizeTabs(checked);
    }

    return () => {
      group.removeEventListener('change', onChange);
      group.removeEventListener('click', onClick);
    };
  }, [groupRef]);
};

export default useTabsLayout;
